<template>
  <div class="box">
    <div class="ddnewsinfo">
      
    </div>
    <div class="newsinfo">
      <!-- <div class="top">
        <router-link to="/">首页</router-link>><span>{{title}}<span v-if="articles.CategoryChild&&articles.CategoryChild.name">>{{ articles.CategoryChild.name }}</span><span v-if="title!='联系我们'">>文章正文</span></span>
      </div> -->
      
      <div class="content">
        <div class="leftitem" :class="!infoFlag?'bigLeft':''">
          <ul class="infoList" v-if="infoFlag">
            <li v-for="(child,index) in CategoryChildren" :key="index" :class="(child.uuid==curChildId)?'activeli':''" @mouseover="changeArticle(child)" @click="enterArticle(child)">
              <i :class="`leftIcon iconfont ${AllIcons[child.name]}`"></i>
               <p> {{ child.name }}</p>
            </li>
          </ul>
          <ul class="generalList" v-else >
            <li class="title">
              {{ articles.CategoryChild?articles.CategoryChild.name:articles.Category.name }}
            </li>
            <li v-for="(hotnew,index) in HotNews" :key="index">
              <h2 @click="$router.push(`/news/info/${hotnew.plateid}/${hotnew.uuid}`)">
                {{ hotnew.title }}
              </h2>
              <p>
                {{hotnew.addtime|filterDate}}
              </p>
            </li>
          </ul>
        </div>
        <div v-if="!islead" class="rightitem" :class="!infoFlag?'smallright':''">
          <div class="title">
            <h2>{{articles.title}}</h2>
            <div v-if="!infoFlag">
              <span class="addtime">发布日期：{{articles.addtime|filterDate}}</span>
              <span>浏览：{{articles.artvisits}}</span>
            </div>
          </div>
          <div class="contentinfo" v-html="articles.contentHtml"></div>
          <!-- <div v-if="articles.filesrc"  class="contentinfo">
            <iframe  :src="`/pdfview?file=/uploads/${articles.filesrc}`"></iframe>
          </div> -->
        </div>
        <div v-else class="rightitem" :class="!infoFlag?'smallright':''">
          <div class="title">
            <h2>企业能力建设教育工作项目组 领导班子</h2>
          </div>
          <div class="contentinfo">
            <ul class="leader">
              <li v-for= "(job,index) in arrJobs" :key="index">
                <div class="job">
                  <span>{{ job.name }}:</span>
                </div>
                <div class="member">
                  <ul>
                    <li v-for="(leader,indexex) in job.LeaderMembers" :key="indexex" :class="leader.url?'hasurl':''" @click="openurl(leader.url)">
                      {{ leader.name }} <i class="el-icon-caret-right" style="float:right;position: relative;top:7px"></i>
                    </li>
                  </ul>
                </div>
                
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getNewsInfo, getNewsViewsZero,getNewsViews,getLeaders } from '@/request/get'
import { AllIcons } from '@/config'
export default {
  name: "NewsInfo",
  data() {
    return {
      plateId: this.$route.params.plateId || '',
      articleId: this.$route.params.articleId || '',
      CategoryChildren:[],
      curChildId:"",
      infoFlag: false,
      AllIcons,
      HotNews:[],
      articles: {
        addtime: "",
        title:"",
        description:"",
        keywords:"",
        CategoryChild:{}
      },
      arrJobs:[],
      islead:false
    }
  },
  filters: {
    filterDate(date) {
      return date.slice(0, 10);
    }
  },
  computed: {
    title() {
      let { plates } = this.$store.state;
      let arrs = plates.filter(item => item.uuid == this.plateId)
      this.CategoryChildren =  arrs[0].CategoryChildren;
      console.log("this.CategoryChildren =",this.CategoryChildren)
      return arrs.length === 0 ? "未配置" : arrs[0].name
    }
  },
  created() {
    this.getNewsInfo();
  },
  mounted() {
    this.toTop();
  },
  methods: {
    openurl(url) {
      
      if(url) window.open(url,'_blank');
    },
    async getNewsInfo() {
      if (this.articleId === "000000") {
        let { plates } = this.$store.state;
        let arrs = plates.filter(item => item.uuid == this.plateId)
        this.CategoryChildren =  arrs[0].CategoryChildren;
        let CategoryChildren;
        if( arrs[0].CategoryChildren&&arrs[0].CategoryChildren.length>0)
        {
          CategoryChildren =  arrs[0].CategoryChildren[0].uuid;
          this.curChildId = CategoryChildren;
        }
        let res = await getNewsViewsZero(this.plateId,CategoryChildren);
        let articles = res.data;
        if (articles.length == 0) {
          return;
        } 
        this.infoFlag = true;
        this.articleId = articles[0].uuid;
      }
      let result = await getNewsInfo(this.articleId);
      this.articles = result.data;
      if (!this.articles.addtime) {
        let addtime = this.articles.createdAt;
        let date = new Date(addtime);
        this.articles.addtime = `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${("00" + date.getHours()).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${("00" + date.getSeconds()).slice(-2)}`
      }
      let childid = null;
      if(this.articles&&this.articles.CategoryChild&&this.articles.CategoryChild.uuid)childid=this.articles.CategoryChild.uuid
      result =  await getNewsViews(this.plateId,0,10,childid);
      this.HotNews = result.data||[];
    },
    async changeArticle(child){
      if(child.name=="会员查询")
      {
        return;
      }else if(child.name=="领导班子"){
        this.islead = true;
        this.curChildId = child.uuid;
        let result = await getLeaders();
        this.arrJobs = result.data||[]; 
        return;
      }
      this.islead = false;
      this.curChildId = child.uuid;
      let res = await getNewsViewsZero(this.plateId, child.uuid);
        let articles = res.data;
        if (articles.length == 0) {
          this.articles ={
            addtime: "",
        title:"",
        description:"",
        keywords:""
          }
          return;
        } 
        this.articleId = articles[0].uuid;
        let result = await getNewsInfo(this.articleId);
        this.articles = result.data;
    },
    async enterArticle(child){
      if(child.name=="会员查询")
      {
        this.$router.push("/InqMember")
      }
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>
<style scoped>
.leader{
  /* display: grid; */
}
.leader li {
  line-height:52px;
  margin-bottom: 10px;;
  cursor:default;
}
.leader li .job {
  display: inline-block;
  width: 120px;

}
.leader li .job span{
  display: inline-block;
    width: 120px;
    text-align: justify;
    text-justify:distribute-all-lines;
    text-align-last: justify;
    font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #000000;
}

.leader li .member{
  display: inline-block;
  width: 930px;

}
.leader li .member ul{
  display: flex;
  flex-flow: row wrap;
}
.leader li .member ul li {
  display:inline-block;
  font-size: 20px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
border-bottom: 1px dashed #000;
line-height: 35px;
padding-top: 20px;;
letter-spacing: 2px;
cursor:default;
margin-left: 46px;
    width: 109px;

/* height: 75px; */
}
.hasurl{
  color: #0041BE !important;
  border-bottom: 1px dashed #0041BE !important;
  cursor:pointer !important;
}
.box{
  position: relative;
  width: 100%;
  /* background-color: #fff; */
}

.newsinfo{
  position: relative;
  width: 1300px;
  /* min-height: 1245px; */
  margin: 0 auto;
  overflow: hidden;

}
.newsinfo .content{
  background-color: #fff;
  padding: 16px 18px 16px 42px;
  display: flex;
    flex-flow: row wrap;
}
.newsinfo .top{
  margin:0px 0 16px 0;
  width: 300px;
  height: 14px;
  font-weight: 500;
  font-size: 14px;
  font-weight: 400;
  color: #D9D9D9;
  line-height: 16px;
}
.newsinfo .top a{
  color: #D9D9D9;
}
.newsinfo .title{
  position: relative;
  height: 22px;
  padding: 22px 0 25px;
  border-bottom: 1px solid #EFEFEF;
  margin-bottom: 13px;
}
.newsinfo .title h2{
  font-size: 22px;

  /* font-weight: bold; */
  color: #000;
  line-height: 22px;
  text-align: left;
}
.newsinfo .title div {
  position: absolute;
  right: 31px;
  bottom: 14px;
  /* display: none; */
}
.newsinfo .title div span{
  height: 14px;
  font-size: 14px;

  font-weight: 500;
  color: #BDBDBD;
  line-height: 14px;
}
.newsinfo .title div span.addtime{
  display: inline-block;
  padding-right: 47px;
}
.newsinfo .contentinfo{
  /* margin-left:38px; */
  width: 1050px;
  /* min-height: 463px; */
  font-size: 14px;

  font-weight: 500;
  color: #333333;
  line-height: 28px;
  padding-bottom: 40px;
}
iframe{
  width: 100%;
    height: 800px;
}

.leftitem {
  width: 183px;
display: inline-block;
}
.leftitem .infoList li{
  width: 127px !important;
  
  height: 72px;
  /* background: #F7FAFF; */
  /* border: 1px solid #0041BE; */
  background: #F8F8F8;
  border-radius: 20px 0px 20px 0px;
  text-align: center;
  padding: 23px 0;
  margin-bottom: 11px;
  color: #000000;
}
.leftitem .infoList .activeli{
    background: #F7FAFF; 
   border: 1px solid #0041BE;
   color: #004FB7;
}
.leftitem .infoList li p{
  margin-top:15px;
  font-size: 18px;
font-family: PingFang SC;
font-weight: 500;

}
.rightitem{
  width: 1050px;
    display: inline-block;
    /* position: absolute; */
}
.leftIcon{
  font-size:43px;
  
}
.leftitem .generalList{
  border: 1px solid #e4e4e4;
  /* padding:10px; */

}
.leftitem .generalList .title{
  background-color: #004fb7;
  font-size:18px ;
  color: #fff;
  text-align: center;
}
.smallright{
  width: 900px;
}
.smallright .contentinfo{
  width: 892px;
}
.generalList h2{
  font-size:16px;
  line-height: 22px;
  height: 48px;
  cursor:pointer;
  overflow: hidden;
}
.generalList li{
  height: 70px;
  padding: 5px 10px;
  /* border-bottom:solid 1px #e4e4e4;  */
}
.generalList li h2::before{
  content: "";
  width: 5px;
    height: 5px;
    background-color: #ff0000;
    overflow: hidden;
    border-radius: 999px;
    display: inline-block;
    position: relative;
    top: -3px;
}
.generalList li p{
  border-bottom: solid 1px #e4e4e4;
  padding-bottom: 9px;
}
.generalList li:last-child p{
  border-bottom:0px;
}
.bigLeft{
  width: 300px;
  margin-right:40px ;
}
.smallright .title{
  height: 62px;  
}
.smallright .title h2{
  text-align: center;
}
.contentinfo section{
  max-width:100% !important;

}
.contentinfo p{
  max-width:100%;
}
.contentinfo img{
  max-width:100%;

}
</style>
